module.exports = __webpack_public_path__ + "static/assets/26a4170c481d21b71495a42ccf1b491e.png";